export default __webpack_public_path__ + "static/media/anonymous-user.bab8bbf9.svg";